import React, { useRef } from "react"
import { TextareaAutosize, Box, Button, styled } from "@material-ui/core"
import { toString } from "lodash"
import { PrintData, PrinterOptions } from "qz-tray"
import { Message } from "../../framework/src/Message"
import { CustomEnums, getCustomEnumName } from "../../blocks/utilities/src/CustomBlockHelpers"
import { runEngine } from "framework/src/RunEngine"

export const LOGO_BASE64 = "data:image/png;base64,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"

type Props = {
    onPrint: (printData: Array<PrintData | string>, printerOptions?: PrinterOptions) => Promise<void>
}

const getString = (codeNumber: number) => String.fromCharCode(codeNumber)

const PrintRaw = ({ onPrint }: Props) => {
    const rawDataRef = useRef<HTMLTextAreaElement>(null)
    const jsonRef = useRef<HTMLTextAreaElement>(null)
    const barcodeRef = useRef<HTMLTextAreaElement>(null)
    const qrCodeRef = useRef<HTMLTextAreaElement>(null)

    const handlePrintRaw = () => {
        onPrint([
            "\x1B\x40" +
            "\x1B\x74\x25" +
            toString(rawDataRef.current?.value)
        ])
    }

    const handlePrintJson = () => {
        try {
            const parsedData = JSON.parse(toString(jsonRef.current?.value))
            onPrint(parsedData)
        } catch (error) {
            console.error(error)
        }

    }

    const hanldePrintRawBarcode = () => {
        const code = toString(barcodeRef.current?.value)

        const barcode = '\x1D' + 'h' + getString(120) +
            '\x1D' + 'f' + getString(0) +
            '\x1d\x48\x32' +
            '\x1D' + 'k' + getString(73) + getString(code.length) + code;

        onPrint(['\n\n\n\n\n' + barcode + '\n\n\n\n\n'])
    }

    const hanldePrintRawQRcode = () => {
        const qrCode = toString(qrCodeRef.current?.value)

        const dots = '\x09';

        const qrLength = qrCode.length + 3;
        const size1 = String.fromCharCode(qrLength % 256);
        const size0 = String.fromCharCode(Math.floor(qrLength / 256));

        const print_data = [
            '\x1B' + '\x40' + 'BEGIN QR CODE' + '\x0A' + '\x0A' + '\x0A' + '\x0A' + '\x0A' + '\x0A',

            '\x1D' + '\x28' + '\x6B' + '\x04' + '\x00' + '\x31' + '\x41' + '\x32' + '\x00',
            '\x1D' + '\x28' + '\x6B' + '\x03' + '\x00' + '\x31' + '\x43' + dots,
            '\x1D' + '\x28' + '\x6B' + '\x03' + '\x00' + '\x31' + '\x45' + '\x30',
            '\x1D' + '\x28' + '\x6B' + size1 + size0 + '\x31' + '\x50' + '\x30' + qrCode,
            '\x1D' + '\x28' + '\x6B' + '\x03' + '\x00' + '\x31' + '\x51' + '\x30',
            '\x1D' + '\x28' + '\x6B' + '\x03' + '\x00' + '\x31' + '\x52' + '\x30',

            'END QR CODE' + '\x0A' + '\x0A' + '\x0A' + '\x0A' + '\x0A' + '\x0A'
        ];

        onPrint(print_data)
    }

    const printDeliveryNote = () => {
        const message = new Message(getCustomEnumName(CustomEnums.CustomActionReducers))
        message.addData(getCustomEnumName(CustomEnums.CustomReducerAction), "PRINT_DELIVERY_NOTE")
        message.addData(getCustomEnumName(CustomEnums.CustomReducerPayload), {
            company_detail: {
              registration_no: "2252012881",
              vat_number: "300420408510003",
            },
            store_detail: {
              store_name: "SIN STORED",
              store_id: "9",
              store_address_arabic: null,
              ar_sub_cr_number: "",
            },
            customer_account: {
              full_name: "dev2",
              full_phone_number: "966564111025",
            },
            order_created_user: {
              full_name: "test  sindhu",
              first_name_arabic: "",
              last_name_arabic: "",
            },
            order: {
              order_id: 1,
              invoice_number: "901240000072",
              drop_date: "30-09-2024 06:12 PM",
              sub_total: "20.75",
              applied_discount: "0.0",
              taxable_amount: "20.75",
              tax: 3.11,
              total: "23.86",
              note: null,
            },
            order_items: [
              {
                total_incl_vat: 0.0,
                vat: 0.0,
                unit_price: "0.0",
                quantity: 3,
                service_name: "prs",
                product_second_name: "PROD1",
                product_name: "PROD1",
                product_desc: "",
                notes: "Item notes",
                upcharge_details: [],
                preferences: null,
                preferences_specifications: "black / Moderate / Multi / Textured",
              },
              {
                total_incl_vat: 21.6,
                vat: 1.6,
                unit_price: "10.0",
                quantity: 2,
                service_name: "prs",
                product_second_name: "crop top-pant",
                product_name: "crop top-pant",
                product_desc: "",
                notes: "Item notes",
                upcharge_details: [],
                preferences: "Mobile test preference",
                preferences_specifications: "black / Moderate / Multi / Textured",
              },
              {
                total_incl_vat: 2.16,
                vat: 0.16,
                unit_price: "2.0",
                quantity: 1,
                service_name: "prs",
                product_second_name: "بلوزة كبيرة ",
                product_name: "Blouse Large ",
                product_desc: "",
                notes: "Item notes",
                upcharge_details: [],
                preferences: null,
                preferences_specifications: "black / Moderate / Multi / Textured",
              },
              {
                total_incl_vat: 108.0,
                vat: 8.0,
                unit_price: "100.0",
                quantity: 1,
                service_name: "prs",
                product_second_name: "wow product 2",
                product_name: "crop top",
                product_desc: "",
                notes: null,
                upcharge_details: [],
                preferences: "",
                preferences_specifications: "black / Moderate / Multi / Textured",
              },
              {
                total_incl_vat: 432.0,
                vat: 32.0,
                unit_price: "100.0",
                quantity: 4,
                service_name: "prs",
                product_second_name: "الوالدين PP2",
                product_name: "Parent PP2",
                product_desc: "",
                notes: "Item notes",
                upcharge_details: [],
                preferences: "a new new new preference",
                preferences_specifications: "black / Moderate / Multi / Textured",
              },
            ],
            earned_points: 0,
            used_points: 0,
            available_points: 0,
            total_pieces: 1,
            order_request_type: "invoice",
            item_services: {
              DC: 1,
            },
            item_preferences: {
              Hanged: 1,
            },
            qr: "data:image/png;base64,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",
            barcode_url:
              "iVBORw0KGgoAAAANSUhEUgAAA3QAAAGGAQAAAAAbLv4tAAABA0lEQVR4nO3Q\n0QnEIBAFwDUNaP9VagXeGggEkt8L3GVE3OeiDrjNR0ff4tnB4/F4PB7vL73R\n2ohoo4yspZUVY20yrXnbzdNH93TtEvPtspdcMr3iP3k8Ho/H4/F4PB6Px+Px\neDwej8fj8Xg8Ho/H4/F4PB6Px+PxeDwej8fj8Xg8Ho/H4/F4PB6Px+PxeDwe\nj8fj8Xg8Ho/H4/F4PB6Px+PxeDwej8fj8Xg8Ho/H4/F4PB6Px+PxeDwej8fj\n8Xg8Ho/H4/F4PB6Px+PxeDwej8fj8Xg8Ho/H+wWv9l4jep016+xzxVibTGve\ndvP00T1du8R8e+4ll0yv+E8ej8fj8XhfHh/NzcaPiW6e3gAAAABJRU5ErkJg\ngg==\n",
            invoice_number_label: "INV# 240000072",
            order_label_text: "Simplified Tax Invoice",
            terms: {
              id: null,
              description:
                "<p>1. Items will be reprocessed free of charge if the customer is dissatisfied with the services.</p>\r\n\r\n<p><br />\r\n2. Items damaged or unsuitable for cleaning will be returned unprocessed.</p>\r\n\r\n<p><br />\r\n3. The laundry accepts no responsibility for any missing, lost, or damaged after leaving the shop.</p>\r\n\r\n<p><br />\r\n4. Compensation for damage or lost items is limited to ten times the cleaning charges with the condition of informing the shopkeeper before leaving the shop.</p>\r\n\r\n<p><br />\r\n5. Compensation for damage or lost carpets is limited to five times the cleaning charges with the condition of informing the shopkeeper before leaving the shop.</p>\r\n\r\n<p><br />\r\n6. The laundry accepts no responsibility for any items left at the shop or factory for more than two months.</p>\r\n",
              description_ar:
                "<p>١. يتم إعادة غسيل القطعة في حال عدم اقتناع العميل بنظافة القطعة بعد إقرار موظف الفرع.</p>\r\n\r\n<p><br />\r\n٢. ستعاد بدون تنظيف الملابس الممزقة والغير صالحة للغسيل.</p>\r\n\r\n<p><br />\r\n٣. نأمل إبلاغ موظف الفرع عن وجود أي نقص أو فقدان أو تلف وذلك عند استلام القطع قبل مغادرة الفرع.</p>\r\n\r\n<p><br />\r\n٤. يتم تعويض العميل بحد أقصى عشر أضعاف قيمة الغسيل في حال التلف أو الفقدان للقطع بشرط إبلاغ الموظف قبل مغادرة الفرع.</p>\r\n\r\n<p><br />\r\n٥. يتم تعويض العميل بحد أقصى خمس أضعاف قيمة الغسيل في حال التلف أو الفقدان للسجاد بشرط إبلاغ الموظف قبل مغادرة الفرع.</p>\r\n\r\n<p><br />\r\n٦. المغسلة غير مسؤولة عن ضياع أو تلف القطع التي يتركها أصحابها لدى المغسلة أو أحد فروعها لمدة تزيد عن شهرين.</p>\r\n",
            }})
        runEngine.sendMessage("Test Print", message)
    }


    return (
        <StyledWrapper>
            <Box display="flex" gridGap={20}>
                <Button
                    type="button"
                    onClick={printDeliveryNote}
                >test delivery note</Button>
                <Button
                    onClick={() => onPrint([
                        "\x1B\x40" +
                        "\x1B\x74\x25" +
                        "\n" +
                        "\x1B\x61\x02" +
                        "\x1B\x24\x64\x00ABCDEFGHJKLMABCDEFGHJKLMABCDEFGHJKLMABCDEFGHJKLMABCDEFGHJKLMABCDEFGHJKLMABCDEFGHJKLMABCDEFGHJKLM\n\x1B\x24\x00\x00123456789" +
                        "\x1D\x4C\x78\x00ABCDEFGHJKLMABCDEABCDEFGHJKLMABCDEABCDEFGHJKLMABCDEABCDEFGHJKLMABCDEABCDEFGHJKLMABCDEABCDEFGHJKLMABCDEABCDEFGHJKLMABCDEABCDEFGHJKLMABCDE\n\x1D\x4C\x00\x00123456789"
                    ])}
                >Sample Raw Margin</Button>
                <Button
                    onClick={() => onPrint(
                        [
                            "\u001b\u001da\u0001\u001bh\u0000\u001bW\u0000\u001bFفاتورة ضريبية مبسطة\nSimple Tax Invoice\n\n\u001bh\u0001\u001bW\u0001\u001bE#Khobar@Master_HA\n\u001bh\u0000\u001bW\u0000\u001bFTel. 920018880 | \u001bE4411790\u001bF\nالرقم الضريبي: ٣٠٠٤٢٠٤٠٨٥١٠٠٠٣\nسجل تجاري: ٢٢٥٢٠١٢٨٨١\n\n-----------------------------------------------\u001bh\u0001\u001bW\u0001\u001bEINV# 232\u001bh\u0000\u001bW\u0000\u001bF\n\u001bb\u0006\u0002\u0002`\u0011447900000232\u0001\u001e------------------------------------------------\nDrop Date: 23\/04\/24\nAdmin :أمين الصندوق\n------------------------------------------------\n\u001bEMuthukumar | Mob: 0550737500\u001bF\n\u001b\u001da\u0000------------------------------------------------\nالوصف       قسم الكمية الوحدة   المضافة  المضافة\nسعر      الضريبة  الضريبة\nقيمة  السعر شامل\n\nSubtotal VAT   Unit Price Qty   Dept       Items\n- - - - - - - - - - - - - - - - - - - - - - - -\n32.75    4.27  28.48      1     B        Blanket                                          بطانية\n42.00    5.48  36.52      1     B Blanket Extra Large                                                                                بطانية كبيرة جدا\n0.00     0.00  0.00       1     B Pillow Case Normal o                                            ffer                             عرض غطاء وسادة عادي\n\n- - - - - - - - - - - - - - - - - - - - - - - -\n65.00                        Sub Total | المجموع\n9.75              VAT | %ضريبة القيمة المضافة 15\n\u001bE74.75\u001bF         Total | إجمالي المستحق بعد الضريبة\n      (VAT 1الاسعار تشمل قيمة الضريبة المضافة %5)\u001bE3\u001bF                     Total Pieces | مجموع القطع\n------------------------------------------------\n\nTest for Custom Receipt\n\n\u001bd\u0003    \n"
                        ],
                    )}
                >Sample 1</Button>
                <Button
                    onClick={() => {
                        const commands = [
                            '\x1B\x1D\x61\x01',
                            'Aljabr Laundry Invoice\n',
                            'Aljabrlaundries Co Ltd\n',
                            '\x0A',

                            '\x1B\x1D\x61\x00',
                            'Simplified Tax Invoice\n',
                            'QALAM 2_RD\n',
                            'CR: 2252012881 | VAT: 300420408510003\n',
                            'INV#240000056\n',
                            'Drop Date: 29-09-2024 10:08 PM\n',
                            'Storekeeper: Mohammad Sanaullah Shafiullah\n',
                            'Mr. Firas | Mob: 966581222578\n',
                            '\x0A',

                            '\x1B\x44\x0A\x14\x1E\x28\x00',
                            'Service        Description    Qty   Unit Price   Total\n',
                            '\x09',
                            'Abayah Normal                 1     21.74        25.00\n',
                            'Scarf                         1     5.87         6.75\n',
                            'Ladies Pant                   1     8.70         10.00\n',
                            '\x0A',

                            '------------------------------------------\n',
                            'Sub Total:               36.30 SAR\n',
                            'VAT:                     5.45 SAR\n',
                            'Total Incl. VAT:         41.75 SAR\n',
                            '------------------------------------------\n',
                            '\x0A',

                            'Terms & Conditions\n',
                            '1. Items will be reprocessed free of charge if customer dissatisfied.\n',
                            '2. Items damaged or unsuitable for cleaning will be returned unprocessed.\n',
                            '3. No responsibility for missing or damaged items after leaving the shop.\n',
                            '\x0A',

                            'Thank you. Please visit us again!\n',
                            '\x1B\x64\x02',
                        ];
                        onPrint(commands)
                    }}
                >
                    Sample 2
                </Button>
                <Button
                    onClick={() => {
                        const barcodeData = '\x1d\x6b\x04' + '123456789012';
                        const qrData = "qrCodeData";

                        const escposCommands = [
                            '\u001D\u0028\u006B\u0004\u0000\u0031\u0041\u0032\u0000',
                            '\u001D\u0028\u006B\u0003\u0000\u0031\u0043\u0004',
                            '\u001D\u0028\u006B\u0003\u0000\u0031\u0045\u0030',
                            `\u001D\u0028\u006B\u0019\u0000\u0031\u0050\u0030${qrData}`,
                            '\u001D\u0028\u006B\u0003\u0000\u0031\u0051\u0030'
                        ].join('');

                        const printData = [
                            '\x1B\x40',
                            '\x1b\x61\x01',
                            'فاتورة ضريبية مبسطة\n',
                            'Simple Tax Invoice\n\n',
                            '--------------------------------\n',
                            'Item         Qty  Price\n',
                            '--------------------------------\n',
                            'Total        $100.00\n\n',
                            '\x1b\x61\x01',
                            barcodeData,
                            '\n\n',
                            '123456789012\n',
                            '--------------------------------\n',
                            escposCommands
                        ];
                        onPrint(printData)
                    }}
                >
                    Sample 3
                </Button>
                <Button
                    onClick={() => {
                        const receipt =
                            "\u001b\u001da\u0001" +
                            "\u001bh\u0000" +
                            "\u001bW\u0000" +
                            "\u001bF" +
                            "\x1B\x74\x25" +
                            "فاتورة ضريبية مبسطة\n" +
                            "Simple Tax Invoice\n\n" +
                            "\u001bh\u0001" +
                            "\u001bW\u0001" +
                            "\u001bE" +
                            "#Khobar@Master_HA\n" +
                            "\u001bh\u0000" +
                            "\u001bW\u0000" +
                            "\u001bF" +
                            "Tel. 920018880 | \u001bE4411790\u001bF\n" +
                            "الرقم الضريبي: ٣٠٠٤٢٠٤٠٨٥١٠٠٠٣\n" +
                            "سجل تجاري: ٢٢٥٢٠١٢٨٨١\n\n" +
                            "-----------------------------------------------\n" +
                            "\u001bh\u0001" +
                            "\u001bW\u0001" +
                            "\u001bE" +
                            "INV# 232\n" +
                            "\u001bh\u0000" +
                            "\u001bW\u0000" +
                            "\u001bF" +
                            "\u001bb\u0006\u0002\u0002`\u0011447900000232\u0001\u001e" +
                            "------------------------------------------------\n" +
                            "Drop Date: 23/04/24\n" +
                            "Admin :أمين الصندوق\n" +
                            "------------------------------------------------\n" +
                            "\u001bE" +
                            "Muthukumar | Mob: 0550737500\n" +
                            "\u001bF\n" +
                            "\u001b\u001da\u0000" +
                            "------------------------------------------------\n" +
                            "الوصف       قسم الكمية الوحدة   المضافة  المضافة\n" +
                            "سعر      الضريبة  الضريبة\n" +
                            "قيمة  السعر شامل\n" +
                            "\n" +
                            "Subtotal VAT   Unit Price Qty   Dept       Items\n" +
                            "- - - - - - - - - - - - - - - - - - - - - - - -\n" +
                            "32.75    4.27  28.48      1     B          Blanket بطانية\n" +
                            "42.00    5.48  36.52      1     B          Blanket Extra Large بطانية كبيرة جدا\n" +
                            "0.00     0.00  0.00       1     B          Pillow Case Normal offer عرض غطاء وسادة عادي\n" +
                            "\n" +
                            "- - - - - - - - - - - - - - - - - - - - - - - -\n" +
                            "65.00                        Sub Total | المجموع\n" +
                            "9.75              VAT | %ضريبة القيمة المضافة 15\n" +
                            "\u001bE" +
                            "74.75\u001bF         Total | إجمالي المستحق بعد الضريبة\n" +
                            "      (VAT 1الاسعار تشمل قيمة الضريبة المضافة %5)\u001bE" +
                            "3\u001bF                     Total Pieces | مجموع القطع\n" +
                            "------------------------------------------------\n" +
                            "\n"
                        "\u001bd\u0003";
                        onPrint([receipt])
                    }}
                >
                    Sample 4
                </Button>
                <Button onClick={() => {
                    const barcodeData = "\x1d\x6b\x08\x7b\x42123456\x00"
                    onPrint([barcodeData])
                }}>
                    Barcode 1
                </Button>
                <Button onClick={() => {
                    const code = "ABC"
                    const barcodeData = '\x1D' + 'k' + getString(73) + getString(code.length + 2) + "\x7B\x42" + code
                    onPrint([barcodeData])
                }}>
                    Barcode 2
                </Button>
                <Button onClick={() => {
                    const code = "ABC"
                    const barcodeData = '\x1D' + 'k' + getString(73) + "\x7B\x42" + getString(code.length) + code
                    onPrint([barcodeData])
                }}>
                    Barcode 3
                </Button>
            </Box>
            <Box display="grid" gridTemplateColumns="0.5fr 0.5fr" gridGap={20}>
                <Box>
                    <p>RAW DATA (STRING)</p>
                    <TextareaAutosize minRows={5} ref={rawDataRef} />
                    <Button onClick={() => handlePrintRaw()}>Print</Button>
                </Box>
                <Box>
                    <p>PRINT DATA ARRAY (JSON)</p>
                    <TextareaAutosize 
                        minRows={5} 
                        ref={jsonRef}
                        placeholder="Enter JSON Object"
                    />
                    <Button onClick={() => handlePrintJson()}>Print JSON</Button>
                </Box>
                <Box>
                    <p>PRINT RAW BARCODE</p>
                    <TextareaAutosize minRows={5} placeholder="Enter Barcode Value" ref={barcodeRef} />
                    <Button data-test-id="print-barcode" onClick={() => hanldePrintRawBarcode()}>Print</Button>
                </Box>
                <Box>
                    <p>PRINT RAW QRCODE</p>
                    <TextareaAutosize minRows={5} placeholder="Enter QR Code Value" ref={qrCodeRef} />
                    <Button onClick={() => hanldePrintRawQRcode()}>Print</Button>
                </Box>
            </Box>
        </StyledWrapper>

    )
}

const StyledWrapper = styled(Box)({
    margin: 32,
    display: "flex",
    flexDirection: "column",
    gap: 20,
    "& .MuiButton-root": {
        background: "blue",
        color: "white"
    }
})

export default PrintRaw